import { Sun, Moon } from "lucide-react";

function Header({ wsConnected, darkMode, onToggleDarkMode }) {
  return (
    <header className="header">
      <div className="header-content">
        <div className="logo">
          <span className="logo-text">ASSET SIMULATOR</span>
        </div>
        <div className="header-actions">
          <div className="coffee-section">
            <div className="coffee-buttons">
              <div className="bmc-button-container">
                <a
                  href="https://www.buymeacoffee.com/mfrdsfzi"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
                    alt="Buy Me A Coffee"
                    style={{ height: "36px", width: "130px" }}
                  />
                </a>
              </div>
              <button
                className="theme-toggle"
                onClick={onToggleDarkMode}
                aria-label={darkMode ? "Switch to light mode" : "Switch to dark mode"}
                title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
              >
                {darkMode ? <Sun size={20} /> : <Moon size={20} />}
              </button>
            </div>
            <span className="coffee-text">
              This web app is fueled by caffeine
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
